<<!-- 查看详情 -->
<template>
  <div class="text-l line-14 fz-14 c-666">
    <el-row>
      <el-col :span="24" class="fz-14 c-000 mt-10 flex-bw">
        <span class="opacity">提报详情</span>
        <span class="c-ea4 pointer mt-27s" @click="goSub">< 返回列表</span>
      </el-col>
    </el-row>
    <el-row class="line-26">
      <el-col :span="3" style="text-align:right;" class="mr-20 pr-20">
        <span>商品链接：</span>
      </el-col>
      <el-col :span="21">
        <span
          class="c-ea4 pointer break-all"
          @click="getPath(detail.goods_out_url)"
        >{{detail.goods_out_url}}</span>
      </el-col>
    </el-row>
    <el-row class="line-26">
      <el-col :span="3" style="text-align:right;" class="mr-20 pr-20">
        <span>商品分类：</span>
      </el-col>
      <el-col :span="21">
        <span>{{smzdm_cat}}</span>
      </el-col>
    </el-row>

    <el-row class="line-26">
      <el-col :span="3" style="text-align:right;" class="mr-20 pr-20">商品标题：</el-col>
      <el-col :span="21">
        <span class="c-666">{{detail.goods_title}}</span>
      </el-col>
    </el-row>


    <el-row class="line-26">
      <el-col :span="3" style="text-align:right;" class="mr-20 pr-20">推广标题：</el-col>
      <el-col :span="21">
        <span class="c-666">{{detail.short_extension_title}}</span>
      </el-col>
    </el-row>
    <el-row class="line-26">
      <el-col :span="3" style="text-align:right;" class="mr-20 pr-20">商品图片：</el-col>
      <el-col :span="21">
        <img :src="detail.goods_img" class="main-pic mr-10 mt-10" @click="bigImg(detail.goods_img)">
      </el-col>
    </el-row>

    <el-row class="line-26">
      <el-col :span="3" style="text-align:right;" class="mr-20 pr-20">包邮：</el-col>
      <el-col :span="21">{{detail.is_postage==1?"包邮":"不包邮"}}</el-col>
    </el-row>
    <el-row class="line-26">
      <el-col :span="3" style="text-align:right;" class="mr-20 pr-20">商品库存：</el-col>
      <el-col :span="21">{{detail.goods_num}}</el-col>
    </el-row>


    <el-row class="line-26">
      <el-col :span="3" style="text-align:right;" class="mr-20 pr-20">价格优势：</el-col>
      <el-col :span="21">{{detail.money_advantage}}</el-col>
    </el-row>
 
    <el-row class="line-26">
      <el-col :span="3" style="text-align:right;" class="mr-20 pr-20">优惠券链接：</el-col>
      <el-col :span="21">
        <span
          v-if="detail.is_have_coupon"
          class="c-ea4 pointer break-all"
          @click="getPath(detail.coupon_url)"
        >{{detail.coupon_url}}</span>
        <span v-else>- -</span>
      </el-col>
    </el-row>
    <el-row class="line-26">
      <el-col :span="3" style="text-align:right;" class="mr-20 pr-20">优惠券生效时间：</el-col>
      <el-col
        :span="21"
        v-if="detail.is_have_coupon"
      >{{detail.coupon_start_time}}至{{detail.coupon_end_time}}</el-col>
      <el-col :span="21" v-else>- -</el-col>
    </el-row>
    <el-row class="line-26">
      <el-col :span="3" style="text-align:right;" class="mr-20 pr-20">优惠券总数量：</el-col>
      <el-col :span="21" v-if="detail.is_have_coupon">{{detail.coupon_num_total}}</el-col>
      <el-col :span="21" v-else>- -</el-col>
    </el-row>
    <el-row class="line-26">
      <el-col :span="3" style="text-align:right;" class="mr-20 pr-20">优惠券剩余数量：</el-col>
      <el-col :span="21" v-if="detail.is_have_coupon">{{detail.coupon_num_suplus}}</el-col>
      <el-col :span="21" v-else>- -</el-col>
    </el-row>
    <el-row class="line-26">
      <el-col :span="3" style="text-align:right;" class="mr-20 pr-20">优惠券金额：</el-col>
      <el-col :span="21" v-if="detail.is_have_coupon">{{detail.coupon_money}}元</el-col>
      <el-col :span="21" v-else>- -</el-col>
    </el-row>
    <el-row class="line-26">
      <el-col :span="3" style="text-align:right;" class="mr-20 pr-20">优惠后价格：</el-col>
      <el-col :span="21">{{detail.real_money}}元</el-col>
    </el-row>
    <el-row class="line-26">
      <el-col :span="3" style="text-align:right;" class="mr-20 pr-20">提交时间：</el-col>
      <el-col :span="21">{{detail.create_time}}</el-col>
    </el-row>
    <el-row class="line-26">
      <el-col :span="3" style="text-align:right;" class="mr-20 pr-20">发布时间：</el-col>
      <el-col
        :span="21"
        v-if="detail.check_audit_time!='0000-00-00 00:00:00'"
      >{{detail.check_audit_time}}</el-col>
      <el-col :span="21" v-else></el-col>
    </el-row>

    <el-row class="line-26" >
      <el-col :span="3" style="text-align:right;" class="mr-20 pr-20">当前状态：</el-col>
      <el-col :span="21">{{detail.status}}</el-col>
    </el-row>

    <el-row class="line-26">
      <el-col :span="3" style="text-align:right;" class="mr-20 pr-20">备注：</el-col>
      <el-col :span="21">{{detail.remark}}</el-col>
    </el-row>
    <el-dialog :visible.sync="dialogVisible" size="tiny">
      <img width="100%" :src="dialogImageUrl" alt>
    </el-dialog>
  </div>
</template>
<script>
import "./tool.css";
export default {
  name: "",
  data() {
    return {
      api: {
        getUserArticleInfo: "/home/getUserArticleInfo" //获取淘宝商品详情
      },
      detail: {},
      dialogVisible: false,
      dialogImageUrl: "",
      article_content: "",
      smzdm_cat:'',//商品分类
    };
  },
  components: {},
  created() {
    this.getUserArticleInfo();
  },
  mounted() {},
  methods: {
    getUserArticleInfo() {
      let _this = this;
      this.$http({
        method: "POST",
        url: _this.api.getUserArticleInfo,
        data: {
          aeid: _this.$route.query.aeid
        }
      }).then(res => {
        if (res.code == 1) {
          _this.detail = res.data;
          _this.article_content = res.data.article_content;
          for(var i=0;i<res.data.smzdm_cat.length;i++){
            if(i!=res.data.smzdm_cat.length-1){
              this.smzdm_cat+=res.data.smzdm_cat[i].name+'/'
            }else{
              this.smzdm_cat+=res.data.smzdm_cat[i].name
            }
          }
        } else {
          _this.$message({
            message: res.data,
            type: "warning"
          });
        }
      });
    },
    getPath(path) {
      window.open(path);
    },
    goSub() {
      this.$router.push({
        name: "singleproduct",
        params: {
          type: 1
        }
      });
    },
    bigImg(path) {
      this.dialogImageUrl = path;
      this.dialogVisible = true;
    },
    //打开优惠券地址
    goConpos(num) {
      if (num == 1) {
        window.open(this.detail.coupon_url);
      } else if (num == 2) {
        window.open(this.detail.coupon_url_2);
      }
    }
  }
};
</script>
<style  scoped>
.fl {
  float: left;
}
.main-pic {
  width: 100px;
  height: 100px;
  cursor: pointer;
}
.pr-20 {
  padding-right: 20px;
}
.mt-27s {
  margin-top: -27px;
}
.break-all {
  word-break: break-all;
}

</style>